import Mutations from '../../odata/mutations';

export default { ...new Mutations('driedAbaloneSummaryItem'), ...new Mutations('driedAbaloneSummaryItems') };
